import { Mail, Clock, FilePlus, Activity, LogOut, Box, Calendar, Bell, Book, Shield, Volume2, HelpCircle } from 'react-feather'

export const ClientNav = [
  {
    header: 'my_candidates'
  },
  {
    id: 'applications',
    title: 'applications',
    icon: <Mail size={20} />,
    navLink: '/candidatures'
  },
  {
    header: 'advertisement'
  },
  {
    id: 'createAd',
    title: 'create_ad',
    icon: <FilePlus size={20} />,
    navLink: '/creer-une-annonce'
  },
  {
    id: 'myOrders',
    title: 'my_orders',
    icon: <Box size={20} />,
    navLink: '/mes-commandes'
  },
  {
    id: 'planning',
    title: 'planning',
    icon: <Calendar size={20} />,
    navLink: '/planification'
  },
  {
    header: 'my_favourites'
  },
  {
    header: 'nav_management'
  },
  {
    id: 'activities',
    title: 'activities',
    icon: <Activity size={20} />,
    navLink: '/activites-generales'
  },
  {
    id: 'notifications',
    title: 'notifications',
    icon: <Bell size={20} />,
    navLink: '/notifications'
  },
  {
    id: 'time',
    title: 'nav_hours',
    icon: <Clock size={20} />,
    navLink: '/releves-heures'
  },
  {
    id: 'documents',
    title: 'agency_docs',
    icon: <Book size={20} />,
    navLink: '#'
  },
  {
    header: 'settings'
  },
  {
    id: 'settings',
    title: 'security',
    icon: <Shield size={20} />,
    navLink: '/parametres'
  },
  {
    id: 'communicate',
    title: 'nav_communicate',
    icon: <Volume2 size={20} />,
    navLink: '/communication'
  },
  {
    id: 'support',
    title: 'nav_support',
    icon: <HelpCircle size={20} />,
    navLink: '/support'
  },
  {
    id: 'logOut',
    title: 'nav_disconnection',
    icon: <LogOut size={20} />,
    navLink: '#',
  }
]

export const ClientNavRestriction = [

  {
    header: 'advertisement'
  },
  {
    id: 'createAd',
    title: 'create_ad',
    icon: <FilePlus size={20} />,
    navLink: '/creer-une-annonce'
  },
  {
    id: 'myOrders',
    title: 'my_orders',
    icon: <Box size={20} />,
    navLink: '/mes-commandes'
  },
  {
    id: 'planning',
    title: 'planning',
    icon: <Calendar size={20} />,
    navLink: '/planification'
  },

  {
    header: 'nav_management'
  },

  {
    id: 'time',
    title: 'nav_hours',
    icon: <Clock size={20} />,
    navLink: '/releves-heures'
  },
  {
    header: 'settings'
  },
  {
    id: 'settings',
    title: 'security',
    icon: <Shield size={20} />,
    navLink: '/parametres'
  },
  {
    id: 'communicate',
    title: 'nav_communicate',
    icon: <Volume2 size={20} />,
    navLink: '/communication'
  },
  {
    id: 'support',
    title: 'nav_support',
    icon: <HelpCircle size={20} />,
    navLink: '/support'
  },
  {
    id: 'logOut',
    title: 'nav_disconnection',
    icon: <LogOut size={20} />,
    navLink: '#',
  }
]
